import { API } from '../constants/api';

import { axiosInterceptor } from './interceptors';

interface NotificationMetadata {
    action?: string;
    quoteId?: number;
    code?: string | null;
    status?: string;
    orderId?: number;
}

export interface NotificationItem {
    id: number;
    title: string;
    description: string;
    notificationType: string;
    metadata: NotificationMetadata;
    moduleName: string;
    referenceId: number;
    createdBy: number;
    createdType: string;
    createdAt: string;
    updatedAt: string;
    isRead?: boolean;
}

interface NotificationListParams {
    page?: number;
    limit?: number;
    moduleName?: string;
}

export const getNotifications = async (params?: NotificationListParams, signal?: AbortSignal): Promise<any> => {
    const response = await axiosInterceptor.get(API.NOTIFICATION.LIST, {
        params,
        signal,
    });

    return response;
};

export const markNotificationsAsRead = async (notificationIds: number[]): Promise<any> => {
    const response = await axiosInterceptor.post(API.NOTIFICATION.MARK_ALL_READ, {
        notificationIds,
    });

    return response;
};

// Marks every notification read for the current user (rows are kept as read history, not
// deleted). Same endpoint as markNotificationsAsRead, signalled via the clearAll flag.
export const clearAllNotifications = async (): Promise<any> => {
    const response = await axiosInterceptor.post(API.NOTIFICATION.MARK_ALL_READ, {
        clearAll: true,
    });

    return response;
};

/**
 * Transform API notification to component-friendly format
 */
export const transformNotification = (notification: NotificationItem) => {
    // Replace ##CODE## placeholder in description with actual code from metadata
    let description = notification.description || '';

    if (notification.metadata?.code) {
        description = description.replace('##CODE##', notification.metadata.code);
    } else {
        description = description.replace('##CODE##', '');
    }

    return {
        id: notification.id,
        type: notification.moduleName || 'Quote',
        title: notification.title || '',
        orderId: notification.metadata?.code || '',
        description,
        approvedBy: '',
        // Real read state from the recipient row; socket payloads carry no isRead, so a live row
        // is unread by definition.
        isNew: !notification.isRead,
        isRead: notification.isRead === true,
        createdAt: notification.createdAt,
        metadata: notification.metadata,
        referenceId: notification.referenceId,
        moduleName: notification.moduleName,
        notificationType: notification.notificationType,
    };
};
